import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import * as actions from "../../../_redux/activity-report/ActivityReportAction";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";

export function ExplanationModal({
  activityId,
  showExplanationModal,
  closeExplanationModal
}) {
  const dispatch = useDispatch();
  const { actionsLoading, explanation } = useSelector(
    (state) => ({
      actionsLoading: state.activityReport.actionsLoading,
      explanation: state.activityReport.explanation
    }),
    shallowEqual
  );

  useEffect(() => {
    if (activityId) dispatch(actions.getExplanation(activityId));
    return () => dispatch(actions.cleanExplanation());
  }, [activityId, dispatch]);

  return (
    <Modal
      show={showExplanationModal}
      onHide={closeExplanationModal}
      aria-labelledby="explanation-title"
    >
      {actionsLoading && <ModalProgressBar />}
      <Modal.Header className="justify-content-center">
        <Modal.Title id="explanation-title">Açıklama</Modal.Title>
      </Modal.Header>      
      <Modal.Body>
        {
          explanation
        }
       </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <button
          type="button"
          className="btn btn-danger"
          onClick={closeExplanationModal}
        >
          Kapat
        </button>
      </Modal.Footer>
    </Modal>
  );
}